import { useAppStore } from "../../store/store";

const SettingsGreeting = () => {
  return (
    <div className="top max-md:mt-[20px] max-md:mb-[30px] mt-[36px] mb-[50px] flex justify-between items-center gap-[36px] flex-wrap">
      <div className="">
        <h1 className="max-sm:text-[24px] text-[28px] 2xl:text-[32px] font-[300] leading-normal">
          Settings
        </h1>
        <p className="text-[16px] 2xl:text-[18px] font-[300] leading-normal">
          Control your profile settings and integrations
        </p>
      </div>
    </div>
  );
};

export default SettingsGreeting;
